<div class="contact-us">
  <div
    class="flex flex-col gap-4 p-5 bg-white border border-solid border-(--color-white-04) relative"
    [class.hidden]="!isExpanded"
    [class.form-contact-us]="isExpanded"
  >
    <div class="expand-icon" (click)="toggleExpanded()" [class.hidden]="!isExpanded">
      <img src="/assets/arrow-chevrons-right.png" alt="expand-icon" />
    </div>
    <div class="flex items-center justify-start gap-2">
      <img src="/assets/e-mail.png" alt="e-mail" />
      <h4 class="text-xl font-semibold capitalize">Contact Us</h4>
    </div>
    <p class="text-sm">Tell us about your issue so we can assist you as quickly as possible.</p>
    <form class="flex flex-col gap-2" [formGroup]="form">
      <div class="flex flex-col pt-1">
        <textarea
          id="issue-description"
          pTextarea
          class="textarea-workflow"
          formControlName="issueDescription"
          pSize="large"
          placeholder="Your issue..."
          rows="4"
        ></textarea>
      </div>

      <div class="flex justify-end pt-2">
        <p-button
          type="button"
          styleClass="btn-contrast-workflow"
          [disabled]="form.pristine || form.invalid || !form.value.issueDescription"
          (onClick)="onSubmit()"
          label="Submit"
        />
      </div>
    </form>
  </div>
  <div class="mail-box" [class.hidden]="isExpanded" (click)="toggleExpanded()">
    <div class="bg-(--bg-banner) py-[14px] px-[28px] rounded-t-sm">
      <p class="text-lg font-bold capitalize text-(--color-white-03)">Contact Us</p>
    </div>
  </div>
</div>
